import React from 'react';

const TwitchIcon: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <img
    src="/twitch.png"
    alt="Twitch"
    width={size}
    height={size}
    style={{ borderRadius: 8, display: 'inline-block', background: '#9147FF' }}
  />
);

export default TwitchIcon; 